module.exports = __webpack_public_path__ + "img/defaultProductIco.67a39cae.png";